import { DecideContactEmploymentCandidateRequest, DecideContactMergeCandidateRequest, DecideRateBurdenBasisRequest, DecideRatePeriodCoercionRequest, RegistryRecordServiceSetPricingSheetContractStartRequest } from '../../../../../../gen/ts/mono/datagateway/v1/registry_records_pb';
import { DecideRegistryMatchCandidateRequest } from '../../../../../../gen/ts/mono/datagateway/v1/registry_resolve_pb';
import { AcceptLaborCategoryCandidateRequest, ApproveLaborCategoryMappingRequest, CorrectLaborCategoryMappingRequest, ProposeLaborCategoryMappingRequest, RejectLaborCategoryCandidateRequest, RejectLaborCategoryMappingRequest, WithdrawLaborCategoryMappingRequest } from '../../../../../../gen/ts/mono/ryugu/v1/ryugu_pb';
import { deliveryClient } from '../../../lib/connect/clients';
import { registryRecordClient } from '../records/registryRecordClient';
const registry = '/mono.datagateway.v1.RegistryRecordService/';
const delivery = '/mono.ryugu.v1.DeliveryService/';
// Explicit allowlist: queue metadata cannot invoke an arbitrary browser RPC.
const calls = {
    [`${delivery}AcceptLaborCategoryCandidate`]: (p)=>deliveryClient.acceptLaborCategoryCandidate(AcceptLaborCategoryCandidateRequest.fromJson(p)),
    [`${delivery}RejectLaborCategoryCandidate`]: (p)=>deliveryClient.rejectLaborCategoryCandidate(RejectLaborCategoryCandidateRequest.fromJson(p)),
    [`${delivery}CorrectLaborCategoryMapping`]: (p)=>deliveryClient.correctLaborCategoryMapping(CorrectLaborCategoryMappingRequest.fromJson(p)),
    [`${delivery}ApproveLaborCategoryMapping`]: (p)=>deliveryClient.approveLaborCategoryMapping(ApproveLaborCategoryMappingRequest.fromJson(p)),
    [`${delivery}RejectLaborCategoryMapping`]: (p)=>deliveryClient.rejectLaborCategoryMapping(RejectLaborCategoryMappingRequest.fromJson(p)),
    [`${delivery}ProposeLaborCategoryMapping`]: (p)=>deliveryClient.proposeLaborCategoryMapping(ProposeLaborCategoryMappingRequest.fromJson(p)),
    [`${delivery}WithdrawLaborCategoryMapping`]: (p)=>deliveryClient.withdrawLaborCategoryMapping(WithdrawLaborCategoryMappingRequest.fromJson(p)),
    [`${registry}DecideRatePeriodCoercion`]: (p)=>registryRecordClient.decideRatePeriodCoercion(DecideRatePeriodCoercionRequest.fromJson(p)),
    [`${registry}DecideRateBurdenBasis`]: (p)=>registryRecordClient.decideRateBurdenBasis(DecideRateBurdenBasisRequest.fromJson(p)),
    [`${registry}DecideContactEmploymentCandidate`]: (p)=>registryRecordClient.decideContactEmploymentCandidate(DecideContactEmploymentCandidateRequest.fromJson(p)),
    [`${registry}DecideContactMergeCandidate`]: (p)=>registryRecordClient.decideContactMergeCandidate(DecideContactMergeCandidateRequest.fromJson(p)),
    [`${registry}SetPricingSheetContractStart`]: (p)=>registryRecordClient.setPricingSheetContractStart(RegistryRecordServiceSetPricingSheetContractStartRequest.fromJson(p)),
    [`${registry}DecideRegistryMatchCandidate`]: (p)=>registryRecordClient.decideRegistryMatchCandidate(DecideRegistryMatchCandidateRequest.fromJson(p))
};
function field(value, path) {
    let current = value;
    for (const key of path.split('.')){
        if (!current || typeof current !== 'object' || Array.isArray(current)) throw new Error('The previous decision returned no revision. Reload before continuing.');
        current = current[key];
    }
    if (current === undefined) throw new Error('The previous decision returned no revision. Reload before continuing.');
    return current;
}
/** Resume after a saved step so a failed second RPC never repeats the first. */ export async function decide(decision, inputs = {}, progress = {
    step: 0
}, onProgress = ()=>{}) {
    let current = progress;
    for(let i = current.step; i < decision.actions.length; i++){
        const action = decision.actions[i];
        const call = calls[action.rpc];
        if (!call) throw new Error('This decision is unavailable in this version.');
        const payload = JSON.parse(action.payloadJson);
        for (const key of action.inputFields){
            if (key in inputs) payload[key] = inputs[key];
        }
        for (const [key, path] of Object.entries(action.payloadFromResponse))payload[key] = field(current.response, path);
        const response = await call(payload);
        current = {
            step: i + 1,
            response: response.toJson()
        };
        onProgress(current);
    }
}
/** CHOOSE_EXISTING is the UI's word for ACCEPT bound to a person already in the registry. */ export function decideEmploymentCandidate(a) {
    const choose = a.decision === 'CHOOSE_EXISTING';
    return registryRecordClient.decideContactEmploymentCandidate({
        id: a.id,
        decision: choose ? 'ACCEPT' : a.decision,
        endPrevious: a.decision !== 'REJECT' && a.endPrevious,
        bindContactId: choose ? a.bindContactId ?? '' : '',
        mintNewContact: !choose && !!a.mintNewContact,
        forceCreate: !choose && !!a.forceCreate,
        reason: a.reason ?? ''
    });
}
